import { defineMosaicComponent } from "@/components/Mosaic/defineMosaicComponent";

import type BrandBase from "@/pages/Brand.Base.vue";

export default defineMosaicComponent<typeof BrandBase>("pages/Brand");
